import React from 'react';
import { connect } from 'react-redux'
import { hashHistory } from 'react-router'
import Paper from 'material-ui/Paper';
import HeaderSmall from '../Components/Header/HeaderSmall';
import Chat from 'material-ui/svg-icons/communication/forum';
import Messages from '../Components/Messaging/List';
import TabStrip  from '../Components/TabStrip';
import RaisedButton from 'material-ui/RaisedButton'
import { 
  loadMessages, 
  loadMessage, 
  showMessagesAction, 
  createNewMessage
} from '../actions/messageActions';
import { decrementBadge } from '../actions/cordovaActions';

class MessagesPage extends React.Component {

  componentDidMount() {
      this.props.showMessages();
      this.props.decrementBadge();
  }
  
  newMessage = () => {
    this.props.createNewMessage();
    this.props.router.push(`/message/0/view`);
  }

  selectMessage = (message) => {
      this.props.loadMessage(message);
      this.props.router.push(`/message/${message.SystemMessageID}/view`);
  };

  returnFunction = () => {
    this.props.showMessages();
    hashHistory.goBack();
  }

  render() {
    return (
      <div>
          <HeaderSmall title="My Messages" goBackFunction={this.returnFunction} />
          <div>
            {this.props.member && this.props.member.IsTwoWayMessagingActive && (
              <div>
                <Paper>
                  <div className="trueno centered" style={{padding:'5px 0 20px 0'}}>
                    <p style={{fontSize:12}}>Need help finding a doctor or have a benefit question?</p>
                    <RaisedButton label="Message a Care Guide" labelStyle={{fontSize:18}} primary={true} icon={<Chat />} onClick={this.newMessage} />
                  </div>
                </Paper>
                <br />
              </div>
            )}
            <Messages messages={this.props.messages} selectMessage={this.selectMessage} /> 
            <TabStrip activeTab={3} />  
          </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadMessages: () => {
      dispatch(loadMessages())
    },
    loadMessage: (id) => {
      dispatch(loadMessage(id));
    },
    showMessages: () => {
      dispatch(showMessagesAction());
    },
    createNewMessage: () => {
      dispatch(createNewMessage());
    },
    decrementBadge: () => {
      dispatch(decrementBadge());
    }

  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member,
    messages: state.thisApp.messaging.messages,
    message: state.thisApp.messaging.message,
    showMessage: state.thisApp.messaging.showMessage
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessagesPage)












// WEBPACK FOOTER //
// ./src/Pages/Messages.js